import { createContext } from 'react';
import Theme from '../records/Theme';

/**
 * Designed to provide a single `Theme` record to internal UI components.
 */
const ThemeContext = /*#__PURE__*/createContext(Theme());
export default ThemeContext;